module.exports = __webpack_public_path__ + "static/media/claimReward.5bfa5b30.wav";